import React from 'react'
import { Card, CardDetailsType, Tag } from '@islandsstofa/react'
import cn from 'classnames'
import { Link } from 'gatsby'

interface CardProps {
  containerClass?: string
  card: CardDetailsType
  image: { url: string; alt: string }
  excerptMaxLen?: number
}

export const CapitalCard = ({
  containerClass,
  card,
  image,
  excerptMaxLen = 80
}: CardProps) => {
  return (
    <Card
      containerClass={containerClass}
      card={card}
      image={image}
      smallerImage
      onRenderFootnote={(item: string, x: number) => (
        <Tag type={x === 0 ? 'transparent' : 'basic'} key={x}>
          {item}
          {x === 0 && <br />}
        </Tag>
      )}
      excerptMaxLen={excerptMaxLen}
    />
  )
}

export const CompanyCard = ({
  containerClass,
  card,
  image,
  excerptMaxLen = 80
}: CardProps) => {
  return (
    <Card
      containerClass={containerClass}
      card={card}
      image={image}
      smallerImage
      onRenderFootnote={(item: string, x: number) => (
        <Tag type='basic' key={x}>
          {item}
        </Tag>
      )}
      excerptMaxLen={excerptMaxLen}
    />
  )
}

export const OpportunityCard = ({
  card,
  wrapperClassName = '',
  className = '',
  excerptMaxLen = 150
}: {
  card: CardDetailsType
  wrapperClassName?: string
  className?: string
  excerptMaxLen?: number
}) => {
  const extraTag =
    card.tags && card.tags.length - 3 > 0 ? `+${card.tags.length - 3}` : null
  if (card.tags && extraTag) {
    card.tags.splice(3, 0, extraTag)
  }
  return (
    <Link key={card.url} to={card.url || ''} className={wrapperClassName}>
      <Card
        containerClass={className}
        card={card}
        image={card.image}
        maxTags={4}
        onRenderFootnote={(item: string, x: number) => (
          <Tag type={x === 0 ? 'transparent' : 'yellow'} key={x}>
            {item}
            {x === 0 && <br />}
          </Tag>
        )}
        excerptMaxLen={excerptMaxLen}
      ></Card>
      <span className='card--category'>{card.category}</span>
    </Link>
  )
}

export const EventCard = ({
  containerClass,
  card,
  image,
  excerptMaxLen = 80
}: CardProps) => {
  return (
    <Card
      containerClass={cn(containerClass, 'card--tall')}
      card={card}
      image={image}
      onRenderFootnote={(item: string, x: number) => (
        <Tag type={x === 0 ? 'transparent' : 'basic'} key={x}>
          {item}
          {x === 0 && <br />}
        </Tag>
      )}
      excerptMaxLen={excerptMaxLen}
    />
  )
}

export const SupportCard = ({ containerClass, card, image }: CardProps) => (
  <Card
    containerClass={containerClass}
    card={card}
    image={image}
    onRenderFootnote={(item, x) => <span key={x}>{item}</span>}
    excerptMaxLen={300}
  />
)

export const AdvisorCard = ({ containerClass, card, image }: CardProps) => (
  <Card
    containerClass={containerClass}
    card={card}
    image={image}
    excerptMaxLen={300}
    smallerImage
  />
)
